// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.5_@swc+helpers@0.5.18__webpack@5.105.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.5_@swc+helpers@0.5.18__webpack@5.105.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --shadow-default: 1px 2px 6px 0 rgba(6, 10, 22, 0.25);

    --proda-neon-blue: #0018ea;
    --proda-neon-blue-10: #d7d9f1;
    --proda-navy-blue: #020734;
    --proda-light-blue: #cadefc;
    --proda-light-blue-120: #95bcfa;
    --proda-light-blue-l95: #e7f0fe;
    --proda-blue-30: #a1a9ef;
    --proda-celtic-blue: #0071d8;
    --proda-black: #060a16;
    --proda-black-10: #62637f;
    --proda-white-110: #f8f8f8;
    --proda-white-120: #e4e4ea;
    --proda-white-130: #d6d6e0;
    --proda-white-150: #bbbbcc;
    --proda-white-l95: #f0f0f4;
    --proda-purple: #660bbd;
    --proda-purple-10: #d5a8ff;
    --proda-lavender: #7885ff;
    --proda-lavender-10: #e3e5ff;
    --proda-red-20: #fbd7e0;
    --proda-red: #ff002f;
    --proda-red-120: #d00127;
    --proda-teal: #009c93;
    --proda-teal-10: #86e2dd;
    --proda-yellow-20: #fffcdd;
    --proda-yellow: #ffc700;
    --proda-yellow-120: #cfa101;
    --proda-green-20: #bceebd;
    --proda-green: #04cd00;
    --proda-green-120: #079201;
    --proda-orange: #fc4100;
    --proda-orange-100: #d83800;
    --proda-dusty-pink: #f2d3d3;
    --proda-white: #fdfdff;
    --proda-neutral-20: #4e4f66;

    --proda-red-100: #fff0f1;
    --proda-light-blue-100: #f0f6fe;

    /* Colour Scheme - Semantic */
    --primary-color: var(--proda-navy-blue);
    --secondary-color: var(--proda-light-blue);
    --tertiary-color: var(--proda-orange);
    --accent-color: var(--proda-neon-blue);
    --danger-bg: var(--proda-red-20);
    --danger-border: var(--proda-red);
    --warning-bg: var(--proda-yellow-20);
    --success-bg: var(--proda-green-20);
    --disabled-bg: var(--proda-white-130);
    --light: var(--proda-white-110);
    --dark: var(--proda-black-10);
    --text-color-dark: var(--proda-black);
    --text-color-disabled: var(--proda-black-10);
    --text-color-light: var(--proda-white);

    --user-edit: var(--proda-purple);
    --proda-default: var(--primary-color);
    --proda-ignored: var(--proda-lavender);

    --assigned: var(--proda-purple);
    --inferred: var(--proda-teal);
    --inferred-bg: var(--proda-teal-10);
    --prev-assigned: var(--proda-neon-blue);
    --unassigned: var(--proda-red);

    --hover-bg: var(--proda-dusty-pink);
    --select: var(--proda-light-blue);

    /* Table */
    --row-header-bg: var(--primary-color);
    --row-header-text: var(--text-color-light);
    --row-pinned-bg: var(--proda-white-130);
    --row-selected-bg: var(--select);
    --row-hover-bg: var(--hover-bg);
    --row-border: var(--proda-white-150);

    --cell-header-bg: var(--primary-color);
    --cell-header-text: var(--text-color-light);
    --cell-selected-bg: var(--select);
    --cell-hover-bg: var(--hover-bg);
    --cell-ignored-bg: var(--disabled-bg);

    /* Others */
    --microsoft-blue: #00a4ef;
}
`, "",{"version":3,"sources":["webpack://./src/ui/ThemeProvider/colors.css"],"names":[],"mappings":"AAAA;IACI,qDAAqD;;IAErD,0BAA0B;IAC1B,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,+BAA+B;IAC/B,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;IACzB,4BAA4B;IAC5B,uBAAuB;IACvB,oBAAoB;IACpB,wBAAwB;IACxB,qBAAqB;IACrB,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;;IAE3B,wBAAwB;IACxB,+BAA+B;;IAE/B,6BAA6B;IAC7B,uCAAuC;IACvC,0CAA0C;IAC1C,qCAAqC;IACrC,sCAAsC;IACtC,gCAAgC;IAChC,iCAAiC;IACjC,oCAAoC;IACpC,mCAAmC;IACnC,qCAAqC;IACrC,+BAA+B;IAC/B,6BAA6B;IAC7B,qCAAqC;IACrC,4CAA4C;IAC5C,sCAAsC;;IAEtC,gCAAgC;IAChC,qCAAqC;IACrC,sCAAsC;;IAEtC,+BAA+B;IAC/B,6BAA6B;IAC7B,mCAAmC;IACnC,uCAAuC;IACvC,8BAA8B;;IAE9B,mCAAmC;IACnC,iCAAiC;;IAEjC,UAAU;IACV,qCAAqC;IACrC,0CAA0C;IAC1C,uCAAuC;IACvC,gCAAgC;IAChC,+BAA+B;IAC/B,oCAAoC;;IAEpC,sCAAsC;IACtC,2CAA2C;IAC3C,iCAAiC;IACjC,gCAAgC;IAChC,qCAAqC;;IAErC,WAAW;IACX,yBAAyB;AAC7B","sourcesContent":[":root {\n    --shadow-default: 1px 2px 6px 0 rgba(6, 10, 22, 0.25);\n\n    --proda-neon-blue: #0018ea;\n    --proda-neon-blue-10: #d7d9f1;\n    --proda-navy-blue: #020734;\n    --proda-light-blue: #cadefc;\n    --proda-light-blue-120: #95bcfa;\n    --proda-light-blue-l95: #e7f0fe;\n    --proda-blue-30: #a1a9ef;\n    --proda-celtic-blue: #0071d8;\n    --proda-black: #060a16;\n    --proda-black-10: #62637f;\n    --proda-white-110: #f8f8f8;\n    --proda-white-120: #e4e4ea;\n    --proda-white-130: #d6d6e0;\n    --proda-white-150: #bbbbcc;\n    --proda-white-l95: #f0f0f4;\n    --proda-purple: #660bbd;\n    --proda-purple-10: #d5a8ff;\n    --proda-lavender: #7885ff;\n    --proda-lavender-10: #e3e5ff;\n    --proda-red-20: #fbd7e0;\n    --proda-red: #ff002f;\n    --proda-red-120: #d00127;\n    --proda-teal: #009c93;\n    --proda-teal-10: #86e2dd;\n    --proda-yellow-20: #fffcdd;\n    --proda-yellow: #ffc700;\n    --proda-yellow-120: #cfa101;\n    --proda-green-20: #bceebd;\n    --proda-green: #04cd00;\n    --proda-green-120: #079201;\n    --proda-orange: #fc4100;\n    --proda-orange-100: #d83800;\n    --proda-dusty-pink: #f2d3d3;\n    --proda-white: #fdfdff;\n    --proda-neutral-20: #4e4f66;\n\n    --proda-red-100: #fff0f1;\n    --proda-light-blue-100: #f0f6fe;\n\n    /* Colour Scheme - Semantic */\n    --primary-color: var(--proda-navy-blue);\n    --secondary-color: var(--proda-light-blue);\n    --tertiary-color: var(--proda-orange);\n    --accent-color: var(--proda-neon-blue);\n    --danger-bg: var(--proda-red-20);\n    --danger-border: var(--proda-red);\n    --warning-bg: var(--proda-yellow-20);\n    --success-bg: var(--proda-green-20);\n    --disabled-bg: var(--proda-white-130);\n    --light: var(--proda-white-110);\n    --dark: var(--proda-black-10);\n    --text-color-dark: var(--proda-black);\n    --text-color-disabled: var(--proda-black-10);\n    --text-color-light: var(--proda-white);\n\n    --user-edit: var(--proda-purple);\n    --proda-default: var(--primary-color);\n    --proda-ignored: var(--proda-lavender);\n\n    --assigned: var(--proda-purple);\n    --inferred: var(--proda-teal);\n    --inferred-bg: var(--proda-teal-10);\n    --prev-assigned: var(--proda-neon-blue);\n    --unassigned: var(--proda-red);\n\n    --hover-bg: var(--proda-dusty-pink);\n    --select: var(--proda-light-blue);\n\n    /* Table */\n    --row-header-bg: var(--primary-color);\n    --row-header-text: var(--text-color-light);\n    --row-pinned-bg: var(--proda-white-130);\n    --row-selected-bg: var(--select);\n    --row-hover-bg: var(--hover-bg);\n    --row-border: var(--proda-white-150);\n\n    --cell-header-bg: var(--primary-color);\n    --cell-header-text: var(--text-color-light);\n    --cell-selected-bg: var(--select);\n    --cell-hover-bg: var(--hover-bg);\n    --cell-ignored-bg: var(--disabled-bg);\n\n    /* Others */\n    --microsoft-blue: #00a4ef;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
